export default __webpack_public_path__ + "static/media/1811.819e7135.png";